// Shared copy for the lead-pipeline cost-warning dialogs. Imported by
// LeadSearchPage (search-confirm + bulk-premium modals) and
// LeadEditPanel (per-row refetch + per-row premium-enrich confirms).
//
// Two enrichment tiers feed every dialog:
//
// - **Basic enrichment** runs on every default search. Mostly free
//   (HMLR / Companies House internal, OpenStreetMap + EPC + postcodes.io
//   open-data, building polygons internal). The only paid component is
//   Mapbox geocoding at ~$0.00075/row, with a 100k-requests/month free
//   tier.
//
// - **Premium enrichment** is operator-opt-in (per-row "Enrich with
//   paid APIs" button or multi-select bulk modal). Adds Google Places
//   Text Search + Google Places Nearby at ~$0.005 each. Falls under
//   Google Maps Platform's shared $200/month free credit which covers
//   ~20,000 rows of Places calls.
//
// Keep the service lists in sync with the BE pipeline:
// `_populate_missing_geocodes` (Mapbox), `_populate_missing_buildings`,
// `_populate_missing_landlords` (HMLR), `_populate_missing_tenants`
// (CH + OSM), `_populate_missing_epc`, and the premium-only
// `run_premium_enrichment` (Google Places Text + Nearby).

export const BASIC_ENRICHMENT_SERVICES =
  "Mapbox geocoding, building polygons, HMLR deeds, Companies House, OpenStreetMap, EPC register";
export const PREMIUM_ENRICHMENT_SERVICES =
  "Google Places Text Search, Google Places Nearby";

// Approximate human-readable duration for the cost-warning modals.
// Used by both LeadSearchPage modals and LeadEditPanel confirms; kept
// here so the unit thresholds (seconds vs minutes) stay consistent.
//
// Estimates are deliberately coarse - the underlying numbers are
// guesses based on row count and per-row latency, and a precise-
// looking "8.3 minutes" implies a confidence the calculation
// doesn't have. Three buckets:
//   <30s  -> "less than 30 seconds"
//   <60s  -> "less than 60 seconds"
//   >=60s -> "N minute(s)" rounded up to the nearest minute
export const formatEtaSeconds = (seconds: number): string => {
  if (seconds < 30) return "less than 30 seconds";
  if (seconds < 60) return "less than 60 seconds";
  const minutes = Math.ceil(seconds / 60);
  return `${minutes} minute${minutes === 1 ? "" : "s"}`;
};
